module.exports = __webpack_public_path__ + "assets/lovable.2a5cf0c0.svg";